import React, { useState } from 'react'
import { Layout, Steps } from 'antd'
import './styles/sidebar.scss'
import { List } from '@phosphor-icons/react'
import { communityStore } from 'state/event/community'

const { Sider } = Layout
const LeagueSidebar: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const { stepCounter, setStepCounter, communityData } = communityStore(
    store => ({
      stepCounter: store.communityStepCounter,
      setStepCounter: store.setCommunityStepCounter,
      communityData: store.communityData,
    }),
  )
  const { Step } = Steps
  const steps = [
    {
      title: 'Step 1',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Create community</b>
          <button
            className={`progress-bar-btn ${
              communityData && communityData.statuses.communityInfo
                ? 'active'
                : 'non-active disabled'
            }`}
            disabled={!communityData?.statuses.communityInfo}
            onClick={() => setStepCounter(0)}
          >
            {communityData && communityData.statuses.communityInfo
              ? 'Review'
              : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 2',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Contact details</b>
          <button
            className={`progress-bar-btn ${
              communityData && communityData.statuses.contactDetails
                ? 'active'
                : communityData?.statuses.communityInfo
                ? 'non-active'
                : 'non-active disabled'
            }`}
            disabled={!communityData?.statuses.communityInfo}
            onClick={() => setStepCounter(1)}
          >
            {communityData && communityData.statuses.contactDetails
              ? 'Review'
              : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 3',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Working hours</b>
          <button
            className={`progress-bar-btn ${
              communityData && communityData.statuses.workingHours
                ? 'active'
                : communityData && communityData.statuses.contactDetails
                ? 'non-active'
                : 'non-active disabled'
            }`}
            disabled={!communityData?.statuses.contactDetails}
            onClick={() => setStepCounter(2)}
          >
            {communityData && communityData.statuses.workingHours
              ? 'Review'
              : 'Start'}
          </button>
        </div>
      ),
    },
  ]

  return (
    <div>
      <div
        className="event-list-icon"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        <List size={30} color="#000" />
      </div>

      <Sider
        className={`side-bar create-event-side-bar  ${
          isSidebarOpen ? 'sidebar-open' : ''
        }`}
        width={'auto'}
        style={{ maxWidth: 'auto' }}
      >
        <div className="d-flex flex-column justify-between stepper-section-header pb-10">
          <div>
            <h2 className="mb-16 create-event-sidebar-heading">
              Create a Community
            </h2>
            <span className="mb-20 complete-all-steps">
              Complete all following stept to create a community
            </span>
            <Steps direction="vertical" current={stepCounter}>
              {steps.map(item => (
                <Step
                  key={item.title}
                  className="stepper event-stepper event-step-bar"
                  title={item.title}
                  description={item.description}
                />
              ))}
            </Steps>
          </div>
        </div>
      </Sider>
    </div>
  )
}

export default LeagueSidebar
